import { AnagraficaUtente, LoggedUserInfo } from '@Interfaces/interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { LanguageService } from './language.service';
import { APP_CONFIG } from '@Core/config/app-config';

type loginInfoResponse = {
  result:any;
  view: LoggedUserInfo
}

type anagraficaUtenteResponse = {
  result:any;
  user: AnagraficaUtente;
}

type deleteAccountResponse = {
  result: {
    code: number,
    desc: string,
    success: boolean
  }
}

@Injectable({
  providedIn: 'root',
})
export class UserService {

  private readonly config = inject(APP_CONFIG);

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private languageService: LanguageService
  ) {}

  /**
   * Retrieve the logged user info
   * @returns {Observable<loginInfoResponse>} the logged user info
   */
  public getLoginInfo() : Observable<loginInfoResponse> {
    let headers = new HttpHeaders()
      .set("jwtToken", this.authService.getToken())
      .set("module", "5")
      .set('channel', 'b2c');

    return this.http.get<loginInfoResponse>(`${this.config.apiUrl}/login`, { headers: headers });
  }

  /**
   * Recupera le informazioni anagrafiche dell'utente loggato
   * @returns {Observable<anagraficaUtenteResponse>} informazioni anagrafiche utente
   */
  public getAnagraficaUtente():Observable<anagraficaUtenteResponse> {

    const LOGIN_TOKEN = this.getLoginTokenFromLocalStorage();

    if(LOGIN_TOKEN === ''){
      return throwError(() => new Error("Authentication token is not available."))
    }

    let headers = new HttpHeaders()
      .set("lang", this.languageService.$language.getValue().lang_code)
      .set("module", "6")
      .set('channel', 'b2c')
      //! Questo token deve essere quello ritornato da /login (salvato in LS come 'loginToken')
      .set("token", LOGIN_TOKEN);

    return this.http.get<anagraficaUtenteResponse>(`${this.config.apiUrl}/account/user`, {headers:headers})
  }

  public deleteUserAccount():Observable<deleteAccountResponse> {
    const LOGIN_TOKEN = this.getLoginTokenFromLocalStorage();

    if(LOGIN_TOKEN === ''){
      return throwError(() => new Error("Authentication token is not available."))
    }

    let headers = new HttpHeaders()
      .set("lang", this.languageService.$language.getValue().lang_code)
      .set("module", "6")
      .set('channel', 'b2c')
      .set("token", LOGIN_TOKEN);

    return this.http.delete<deleteAccountResponse>(`${this.config.apiUrl}/account/user`, {headers:headers})
  }

  /**
   * Salva in local storage il token restituito da /login
   * @param token - il token restituito dalla chiamata a /login
   */
  public saveLoginTokenToLocalStorage(token: string): void {
    localStorage.setItem('loginToken', JSON.stringify(token));
  }

  /**
   * Recupera il token restituito dalla chiamata /login
   * @returns {string} - token restituito dalla chiamata /login
   */
  public getLoginTokenFromLocalStorage():string {
    return localStorage.getItem('loginToken') || '';
  }

}
